export const getBuildersMenuItems = (callback) => {
    let items = [
        {
            title: 'Block',
            description: "Create a block portfolio securities",
            onClick: () => { callback('b'); },
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/builder-icons/block-portfolio-shapes.jpeg',
            type: 'b'
        },
        {
            title: 'Sleeve',
            onClick: () => { callback('s'); },
            description: "Sleeves allow you to combine both blocks and securities",
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/builder-icons/sleeve-alt-2.jpeg',
            type: 's'
        },
        {
            title: 'Model',
            description: "Create a model portfolio combining sleeves, blocks, and securities for your end portfolio for clients",
            onClick: () => { callback('m'); },
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/builder-icons/sleeve-portfolio-shapes.jpeg',
            type: 'm'
        },
        {
            title: 'Model of Models',
            description: "Create a client portfolio allowing you to streamline multiple models into a personalized solution for your clients",
            onClick: () => { callback('mm'); },
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/builder-icons/sleeve-portfolio-shapes.jpeg',
            type: 'mm'
        },
        {
            title: "Import from File",
            description: "Import a CSV file to create a portfolio",
            onClick: ()=>{
                callback('import from file');
            },
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/utility/file-upload.png'
        }
    ];
    items.reverse();
    return items;
};
